export class PublicBrandCategory {
  public constructor(public readonly name: string) {}
}
